export default __webpack_public_path__ + "static/media/DisTick.c5191a06.svg";